<template>
    <div>
        <multiselect v-model="model"
                     tag-placeholder="Add this as new tag"
                     placeholder="Search or add a tag"
                     :options="options"
                     :multiple="true"
                     :taggable="true"
                     @tag="addTag"
                     :style="hasError ? { 'border-width': '1px' } : {}"
                     :class="{ 'is-invalid' : hasError }"
        />
    </div>
</template>

<script>
    import multiselect from 'vue-multiselect'
    let _ = require('lodash')

    export default {
        name: 'tags',
        props: {
            value: Array,
            hasError: Boolean
        },
        data() {
            return {
                options: []
            }
        },
        computed: {
            model: {
                get() {
                    return this.value
                },
                set(val) {
                    this.$emit('input', val)
                }
            }
        },
        mounted() {
            this.fetchTags()
        },
        components: {
            multiselect
        },
        methods: {
            fetchTags() {
                this.$api.tags.get({ per_page: 1000 }).then(tags => {
                    this.options = _.map(tags.data, 'name.en')
                })
            },
            addTag(tag) {
                // Translate tags
                let translated = _(this.$config.config.availableLanguages).mapKeys().mapValues(() => {
                    return tag
                }).value()

                // Create tags
                this.$api.tags.create({
                    name: translated
                }).then(() => {
                    this.fetchTags()
                })
            }
        }
    }
</script>